
<div *ngIf="path!='feed'">
<div class="card border hover-shadow list-group-item justify-content-between mb-1" [routerLink]="getRouteSegment()" [fragment]="fragment">
  <div class="d-flex align-items-center">
    <img [src]="imgUrl" alt="" style="width: 60px; height: 60px" loading="lazy" class="rounded-circle shadow-5 img-card" />
    <div class="ms-3">
      <p class="fw-bold text-card-title mb-1">{{ title }}</p>
      <p class="text-muted mb-0">{{ information }}</p>
    </div>
  </div>
</div>
</div>
